const Squareup = ({
    squareupAccessToken,
    setSquareupAccessToken,
    locationId,
    setLocationId,
    setEnvironment,
    environment,
    errors,
    touched,
    handleChange,
    handleBlur,
}) => {
    const Environment = {
        production: "production",
        sandbox: "sandbox",
    };

    return (
        <>
            <div className="col-span-1 col-start-1">
                <label
                    htmlFor="squareupAccessToken"
                    className="block text-sm font-medium text-gray-700"
                >
                    Squareup Access Token
                </label>
                <input
                    type="text"
                    id="squareupAccessToken"
                    name="squareupAccessToken"
                    value={squareupAccessToken}
                    onChange={(e) => {
                        const { value } = e.target;
                        handleChange("squareupAccessToken", value);
                        setSquareupAccessToken(value);
                    }}
                    onBlur={handleBlur}
                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                />
                {errors.squareupAccessToken && touched.squareupAccessToken ? (
                    <div className="mt-2 text-sm font-bold text-red-400">
                        {errors.squareupAccessToken}
                    </div>
                ) : null}
            </div>

            <div className="col-span-1 col-start-1">
                <label
                    htmlFor="locationId"
                    className="block text-sm font-medium text-gray-700"
                >
                    Location Id
                </label>
                <input
                    type="text"
                    id="locationId"
                    name="locationId"
                    value={locationId}
                    onChange={(e) => {
                        const { value } = e.target;
                        handleChange("locationId", value);
                        setLocationId(value);
                    }}
                    onBlur={handleBlur}
                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                />
                {errors.locationId && touched.locationId ? (
                    <div className="mt-2 text-sm font-bold text-red-400">
                        {errors.locationId}
                    </div>
                ) : null}
            </div>

            <div className="col-span-1 col-start-1">
                <div>
                    <input
                        checked={environment === Environment.production}
                        type="radio"
                        id="production"
                        name="environment"
                        value="production"
                        onChange={(e) => {
                            const { value } = e.target;
                            handleChange("environment", value);
                            setEnvironment(value);
                        }}
                        style={{ boxShadow: "none" }}
                    />
                    <label
                        htmlFor="production"
                        className="ml-2 text-sm font-medium text-gray-700"
                    >
                        Production
                    </label>
                </div>
                <div>
                    <input
                        checked={environment === Environment.sandbox}
                        type="radio"
                        id="sandbox"
                        name="environment"
                        value="sandbox"
                        onChange={(e) => {
                            const { value } = e.target;
                            handleChange("environment", value);
                            setEnvironment(value);
                        }}
                        style={{ boxShadow: "none" }}
                    />
                    <label
                        htmlFor="sandbox"
                        className="ml-2 text-sm font-medium text-gray-700"
                    >
                        Sandbox
                    </label>
                </div>
                {errors.environment && touched.environment ? (
                    <div className="mt-2 text-sm font-bold text-red-400">
                        {errors.environment}
                    </div>
                ) : null}
            </div>
        </>
    );
};
export default Squareup;
